
import React from "react"; 
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from 'sweetalert2';

const SubscripcionSuccess = () => {
  const [mensaje, setMensaje] = useState("Procesando pago...");
  const { search } = useLocation();

  let baseUrl;
  if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
  else baseUrl='https://app-formacion.vercel.app';

  useEffect(() => {
    const params = new URLSearchParams(search);
    const subscripcionId = params.get("subscripcionId");
    const sessionId = params.get("session_id");

    if (!sessionId || !subscripcionId) {
      setMensaje("No se puede completar la suscripción.");
      return;
    }

    //Avisar al usuario
    Swal.fire({
      icon: 'success',
      title: '¡Suscripción exitosa!',
      text: 'Pago de suscripción exitoso. Registrando tu cuenta de tutor…',
      confirmButtonText: 'OK'
    });

    //Recuperar los datos completos del tutor
    const tutorPendienteRaw = localStorage.getItem("tutorPendiente");
    if (!tutorPendienteRaw) {
      setMensaje("No se encontraron datos del tutor para completar el registro.");
      return;
    }
    const tutorData = JSON.parse(tutorPendienteRaw);

    //Llamamos al backend para confirmar la suscripción 
    fetch(`${baseUrl}/api/users`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tutorData),
    })
      .then(async (res) => {
        if (!res.ok) throw new Error("Error al crear el usuario tutor en la BD");

        setMensaje("Tutor registrado correctamente. Iniciando sesión…");

        //Iniciar sesión automático
        const userFetch = await fetch(
          `${baseUrl}/api/users/search/${tutorData.Correo}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );

        const user = await userFetch.json();
        localStorage.setItem("userLogueado", JSON.stringify(user));

        //Limpiar localStorage
        localStorage.removeItem("tutorPendiente");

        //Redirigir a la página de inico de tutor
        window.location.href = "/tutor";
      })
      .catch((err) => {
        console.error(err);
        setMensaje(
          "Hubo un error registrando al tutor. Contacta con soporte."
        );
        // Limpiar localStorage
        localStorage.removeItem("tutorPendiente");
      });
  }, [search]);

  return (
    <div 
        style={{ 
            minHeight: 'calc(100vh - 100px)', 
            paddingTop: '60px', 
            background: 'var(--bg-home)',
            color: 'var(--text-principal)' 
            }}
    >
      <h2>{mensaje}</h2>
    </div>
  );
};

export default SubscripcionSuccess;